import {
  LOCALE_SET_FULFILLED,
  LOCALE_SET_FAILED,
  LOCALE_UPDATE_USER_ROLES,
  UPDATE_MESSAGES,
  LOCALE_SET_STARTED,
  LOCALE_SET_USER_ISADMIN_FULFILLED,
  LOCALE_SET_PROJECTS,
  LOCALE_SET_PROJECTS_TRANSLATIONS,
  UPDATE_TRANSLATIONS
} from "../actionTypes/actionTypes";

const demoMsg = {
  sampleMsg: "this is an sample msg",
  newModelBtnLabel: "New Model",
};

const persistState = localStorage.getItem("localeSettings");

const initialState = persistState
  ? JSON.parse(persistState)
  : {
      lang: "en",
      name: "English",
      unit: "Metric",
      error: "",
      fullLangCode: "en-US",
      leafLocale: "en",
      translations: {},
      message: { ...demoMsg },
      role: { name: "anonymous" },
      userRoles: ["Anonymous"],
      isLoading: false,
      transKey: "",
      isAdmin: false,
      projects: [],
      projectTranslations: {}
    };

export const localeReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCALE_SET_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case LOCALE_SET_FULFILLED:
      const payload = {
        ...state,
        lang: action.data.lang,
        name: action.data.Language,
        unit: action.data.UnitSystem,
        role: action.data.Role,
        fullLangCode: action.data.fullLangCode,
        leafLocale: action.data.leafLocale,
        message: action.data.message,
        transKey: action.data.transKey,
        isLoading: false,
      };
      localStorage.setItem("localeSettings", JSON.stringify(payload));
      return payload;
    case LOCALE_SET_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case UPDATE_MESSAGES:
      const msgPayload = {
        ...state,
        message: action.data,
      };
      localStorage.setItem("localeSettings", JSON.stringify(msgPayload));

      return msgPayload;
    case UPDATE_TRANSLATIONS:
      const transPayload = {
        ...state,
        translations: action.data,
      };
      localStorage.setItem("localeSettings", JSON.stringify(transPayload));

      return transPayload;
    case LOCALE_UPDATE_USER_ROLES:
      return {
        ...state,
        userRoles: action.data.userRoles,
      };
    case LOCALE_SET_USER_ISADMIN_FULFILLED:
      return {
        ...state,
        isAdmin: action.data.isAdmin,
      };
    case LOCALE_SET_PROJECTS:
      return {
        ...state,
        projects: action.data.projects,
      };
    case LOCALE_SET_PROJECTS_TRANSLATIONS:
      return {
        ...state,
        projectTranslations: action.data,
      };
    default:
      return state;
  }
};
